export enum AGGREGATED_HEALTH_STATUS {
  HEALTHY = 'healthy',
  UNHEALTHY = 'unhealthy',
  UNKNOWN = 'unknown',
  NOT_CONNECTED = 'not_connected',
}
